import { GroupList } from '@/admin/entities/group/GroupList';
import { RoleList } from '@/admin/entities/role/RoleList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { OutOfOfficeDetail } from '../outOfOffice/OutOfOfficeDetail';

export const UserDetail = () => {
  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'groupsTab', label: 'Groups', content: <GroupList userObj={entityObj} /> },
    { id: 'rolesTab', label: 'Roles', content: <RoleList userObj={entityObj} /> },
    {
      id: 'outOfOfficeTab',
      label: 'Out of Office',
      content: <OutOfOfficeDetail userObj={entityObj} />,
    },
  ];

  return <EntityDetail key={entityObj} tabSpecs={tabSpecs} />;
};
